<template>
  <v-row dense justify="end">
    <template v-for="button of buttonList">
      <ent-button :key="button.name" :config="button.config" @button-event="updateButtonState(button.name)">
        {{getPhrase(button.label)}}<v-icon dark right>{{button.icon}}</v-icon>
      </ent-button>
    </template>
  </v-row>
</template>
<script setup>
// Components Used
  import EntButton from "@/../../library/view/EntButton.vue";

// Phrase Mapper Library
  import phraseProc from "@/../../library/helper/phrase.js";

// Helper libraries to access the store
  import useVuexPathify from "@/../../library/compFunctions/useVuexPathify.js";
  import { ref, getCurrentInstance, watch, onMounted} from "vue";

  const props = defineProps({ config: { type: Object, required: false } });
  const emit = defineEmits(["update:buttonclick"]);
  const vm = getCurrentInstance();
  //console.log(`###### PROPS = `, props);
  const { get } = useVuexPathify(vm.proxy);
  const userlang = get("misc/language").value;
  const phrases = get("misc/phraseMap").value;
  //console.log(`Phrases = `, phrases);

  // Default values for show status of buttons
  let buttonList = ref([])

  // Run button setup when component is mounted
  onMounted(() => runSetup());
  // Run button setup when the props are changed
  watch(props, () => runSetup())

  const runSetup = () => {
    console.log("$$$$$ NAV BUTTON ROW SETUP", props);
    buttonList.value = props.config.buttonList
  };

  // Handle button clicks
  const updateButtonState = (key) => {
    //console.log(`Nav Button Row - updating button state: ${key}`);
    emit("update:buttonclick", { click: key });
  };

  // Handle the phrase translations
  const getPhrase = (item) => {
    return phraseProc.mapPhrase(item, phrases, userlang).toUpperCase();
  };
</script>
